// Validation regex patterns
export const LETTER_NUMBERS_SPACES_HYPHENS_AND_UNDERSCORES = /^[a-zA-Z0-9\s\-_]+$/;